import script from "./WrongQuestionDownloadModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./WrongQuestionDownloadModal.vue?vue&type=script&setup=true&lang=ts"

import "./WrongQuestionDownloadModal.vue?vue&type=style&index=0&id=d52614ce&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d52614ce"]])

export default __exports__